var map = {
	"./de.json": "6ce2",
	"./deold.json": "c9b6",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./fr_20211129.json": "2c03",
	"./frold.json": "1a14",
	"./frold_20211015.json": "4941",
	"./it.json": "0825",
	"./itold.json": "e641"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";